import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL



export function getGraficaDataIn(SuscriptionId:String, CloudAccountId:String) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/cloud/'+CloudAccountId+'/historicalForOperation')
  }

export function getDataConnector(SuscriptionId:Number,source:string,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/AvailableMonth?source='+source,{params:{cloud,region}})
  }

export function getDataConnectorGlobal(SuscriptionId:Number,tenant:number,source:string,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/AvailableMonth?tenantId='+tenant+'&source='+source,{params:{cloud,region}})
  }

export function getCTXStatus (SuscriptionId:Number, cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CTXInstancesHealth',{params:{cloud,region}})
  }

export function getCTXStatusGlobal (SuscriptionId:Number,tenant:number,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CTXInstancesHealth?tenantId='+tenant,{params:{cloud,region}})
  }

export function getInstances (SuscriptionId:Number, source:string,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instances?source='+source,{params:{cloud,region}})
  }

export function getInstancesGlobales (SuscriptionId:Number,tenant:number,source:string,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instances?tenantId='+tenant+'&source='+source,{params:{cloud,region}})
  }

export function getStatusSesiones (SuscriptionId:Number,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instances/-1/ShowBGPSummary',{params:{cloud,region}})
  }
export function getStatusSesionesglobales (SuscriptionId:Number,tenant:number,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instances/-1/ShowBGPSummary?tenantId='+tenant,{params:{cloud,region}})
  }
//////////////////////////
export function getCTXConnectorstatus (SuscriptionId:Number ,signal:any,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CTXConnectorHealth',{signal:signal, params:{cloud,region}}     );
  }
  ///////////////////////////////
export function getCTXConnectorstatusGlobal (SuscriptionId:Number, tenant:number,signal:any,cloud?:any,region?:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CTXConnectorHealth?tenantId='+tenant,{signal:signal, params:{cloud,region}});
  }

export function getCloudStatus (SuscriptionId:Number,Type:String,nameregion:String) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CloudHealth?type='+Type+'&region='+nameregion)
  }

export function getCloudStatusGlobal (SuscriptionId:Number,Type:String,nameregion:String,tenant:number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CloudHealth?type='+Type+'&region='+nameregion+'&tenantId='+tenant)
  }

export function getCloudsStatus (SuscriptionId:Number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CloudHealth')
  }

export function getCloudsStatusG (SuscriptionId:Number,tenant:number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CloudHealth?tenantId='+tenant)
  }

export function getTopology (SuscriptionId:Number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/topology')
  }

export function getsuscription () {
    return axios.get(API_URL+'/v1/suscription')
  }

export function getsuscriptionglobal (tenant:number) {
    return axios.get(API_URL+'/v1/suscription?tenantId='+tenant)
  }


